import { get } from 'lodash';
import config from '$config';

export const KLARNA_FINANCING = 'klarna';

export const shouldShowKlarnaReauthorisationLink = (booking) => {
  const customerTotalPriceWithVAT = get(booking, 'quote.customerTotalPriceWithVAT', 0);
  const proposedCustomerTotalPriceWithVAT = get(booking, 'proposedWork.customerTotalPriceWithVAT', 0);
  const authorisedAmount = get(booking, 'paymentMethod.paymentMethod.authorisedAmount', 0);
  const paymentSource = get(booking, 'paymentMethod.paymentMethod.source', '');
  const totalWithProposed = proposedCustomerTotalPriceWithVAT + customerTotalPriceWithVAT;

  if (paymentSource === KLARNA_FINANCING && customerTotalPriceWithVAT !== authorisedAmount) {
    if (totalWithProposed === authorisedAmount) return false;
    return true;
  }
  return false;
};

export const buildKlarnaReauthorisationUrl = (bookingId, segment) => {
  const baseUrl = segment === "FIXTER-UK" ? config.landingUrl : config.landingUrlFr;
  return `${baseUrl}customer/bookings/${bookingId}/reauthorise-payment`;
}
